import { PreloadImage } from '@nackle/arcade-core-v2';
import { Spin } from '@nackle/origami';
import React, { Component } from 'react';

export class GameImage extends Component {
    state = {};

    render() {
        const {
            src,
            alt,
            className
        } = this.props;
        const { imageLoaded } = this.state;

        return (
          <div className="game-cover-image-container">
            { /* Preload image */ }
            <PreloadImage
              url={ src }
              alt={ alt }
              onPreloadComplete={ this.handleImagePreloaded }
            />

            { /* Spinner while loading */ }
            { !imageLoaded && (
              <Spin size="mini" className="game-cover-image-spinner" />
            ) }

            { /* Actual image when loaded */ }
            { imageLoaded && (
              <img
                src={ src }
                alt={ alt }
                draggable={ false }
                className={ className }
              />
            ) }
          </div>
        );
    }

    handleImagePreloaded = () => this.setState( { imageLoaded: true } );
}
